"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  /**
   * Returns month name by month number
   * @param {number} month - Month number (0-11)
   */
  getMonthName(month) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return monthNames[month];
  },

  /**
   * Returns Date object by unix timestamp
   * @param {string} timestamp - date unix timestamp
   * @returns {Object} - Date object
   */
  getDateByUnixTimestamp(timestamp) {
    return new Date(timestamp * 1000);
  },

  /**
   * Returns formatted date string by unit timestamp.
   * For example: if the timestamp is 1571317125703, the result will be:
   * Oct 17 2019
   * @param {string} timestamp - date unix timestamp
   * @returns {string} - Formatted date string. Example: Oct 17 2019
   */
  getFormattedDate(timestamp) {
    const date = this.getDateByUnixTimestamp(timestamp);
    return "".concat(this.getMonthName(date.getMonth()).substring(0, 3), " ").concat(date.getDate(), " ").concat(date.getFullYear());
  },

  /**
   * Returns formatted date string by unit timestamp.
   * For example: if the timestamp is 1571317125703, the result will be:
   * October 17 2019
   * @param {string} timestamp - date unix timestamp
   * @returns {string} - Formatted date string. Example: October 17 2019
   */
  getFullFormattedDate(timestamp) {
    const date = this.getDateByUnixTimestamp(timestamp);
    return "".concat(this.getMonthName(date.getMonth()), " ").concat(date.getDate(), " ").concat(date.getFullYear());
  }

};
exports.default = _default;